<template>
    <fragment>
        <out-put-page
            title="Nous et notre projet"
            sectionRef="notre_project"
            v-on:page-updated="handleAfterRender"
        >
            <section>
                <h3>Notre projet</h3>

                <notre-project
                    :entreprise="entrepriseInfo"
                    :project="projectInfo"
                />
            </section>
        </out-put-page>
    </fragment>
</template>

<script>
import Vue from "vue";
import NotreProject from "../components/NotreProjet";
import Partners from "../components/Partners";
import SellersCards from "../components/sellersCards";
import ProductsCards from "../components/productsCards";
import OutPutPage from "../components/OutPutPage";
import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";

const pageContentHeight = 1500;
const SellersComponent = Vue.extend(SellersCards);
const OutPageComponent = Vue.extend(OutPutPage);
const ProductsComponent = Vue.extend(ProductsCards);
const PartnersComponent = Vue.extend(Partners);

export default {
    components: {
        NotreProject,
        // eslint-disable-next-line
        Partners,
        // eslint-disable-next-line
        SellersCards,
        // eslint-disable-next-line
        ProductsCards,
        OutPutPage
    },
    props: {
        clients: {
            type: Array,
            require: true
        },
        sellers: {
            type: Array,
            require: true
        },
        entrepriseInfo: {
            type: Object,
            require: true
        },
        projectInfo: {
            type: Object,
            require: true
        },
        offers: {
            type: Array,
            require: true
        }
    },
    data() {
        return {
            data: [],
            renderTrigger: ""
        };
    },

    mounted() {
        const $vm = this;
        this.data.push(
            {
                data: this.entrepriseInfo.partners,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.partners.push({
                            percentage: data.percentage,
                            isManager: data.isManager,
                            name: data.name
                        });
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.partners.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.componentInstance = new PartnersComponent({
                        propsData: {
                            partners: []
                        }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Nous et notre projet",
                            sectionRef: "notre_project"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.notre_project.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML = "Associés";
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            },
            {
                data: this.offers,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.products.push({
                            ...data
                        });
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.products.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.componentInstance = new ProductsComponent({
                        propsData: { products: [] }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Nous et notre projet",
                            sectionRef: "notre_project"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.notre_project.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                    const ProductSection = document.createElement("section");
                    const ProductSectionTitle = document.createElement("h3");
                    ProductSectionTitle.innerHTML = "Produits et Services";
                    ProductSection.appendChild(ProductSectionTitle);
                    this.componentInstance.$mount();
                    ProductSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(ProductSection);
                }
            },
            {
                data: [...this.clients, ...this.sellers],
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.sellers.push({
                            ...data
                        });
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.sellers.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.componentInstance = new SellersComponent({
                        propsData: { sellers: [] }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Nous et notre projet",
                            sectionRef: "notre_project"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.notre_project.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                    const SellersSection = document.createElement("section");
                    const SellersSectionTitle = document.createElement("h3");
                    SellersSectionTitle.innerHTML = "Clients et Fournisseurs";
                    SellersSection.appendChild(SellersSectionTitle);
                    this.componentInstance.$mount();
                    SellersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(SellersSection);
                }
            }
        );

        this.handleAfterRender();
    },
    methods: {
        handleAfterRender(contentHeight) {
            for (const instance of this.data) {
                if (instance.firstItemLock && instance.data.length > 0) {
                    instance.initComponent();
                    if (pageContentHeight - contentHeight < 300)
                        instance.newPage();
                    instance.initSection();
                    instance.firstItemLock = false;
                }
                if (contentHeight >= pageContentHeight) {
                    instance.pop();
                    instance.initComponent();
                    instance.newPage();
                    instance.initSection();
                    instance.seed(instance.prevData);
                } else {
                    instance.seed();
                }
                break;
            }
        }
    }
};
</script>

<style></style>
